import React from "react";
import PropertyThumbnailGallery from "./PropertyThumbnailGallery";

export default function PropertyThumbnailGalleryContainer(props) {
  return <PropertyThumbnailGallery {...props} />
}